import api from '../../api/client';
import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { usePermissions } from '../../permissions';
import { BASE_URL } from '../../config/constant';

const RoleBasedGuard = ({ children }) => {
    const { filteredNavigation, loading } = usePermissions();
    const location = useLocation();
    const currentPath = location.pathname;

    // Wait until permissions are loaded
    if (loading) {
        // You can return a loading spinner or null while waiting
        return null; // or <LoadingSpinner />
    }

    const flattenRoutes = (items, parentPath = '') => {
        return items.reduce((acc, item) => {
            const fullPath = `${parentPath}${item.path || ''}`;
            if (item.children) {
                acc.push({ ...item, path: fullPath });
                acc.push(...flattenRoutes(item.children, fullPath));
            } else {
                acc.push({ ...item, path: fullPath });
            }
            return acc;
        }, []);
    };

    const allRoutes = flattenRoutes(filteredNavigation);
    const currentRoute = allRoutes.find((route) => route.url === currentPath);
    const viewPermission = currentRoute ? currentRoute.permissions.view_permission : false;

    if (!viewPermission) {
        return <Redirect to={BASE_URL} />;
    }

    const childWithProps = React.cloneElement(children, { viewPermission });
    return childWithProps;
};

export default RoleBasedGuard;
